import { GateKeepingCandidate } from './../../../gate-keeping.model';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-gate-keeper-candidate-details',
  templateUrl: './gkc-candidate-details.component.html',
  styleUrls: ['./gkc-candidate-details.component.scss']
})
export class GKCCandidateDetailsComponent {

  @Input() gateKeepingCandidate: GateKeepingCandidate;
}
